
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="purchaseItemsList"
          item-value="id"
          item-text="name"
          :search-input.sync="itemsSearch"
          no-filter
          @input="selectItem"
          no-data-text="Nenhum Item encontrado, faça outra busca"
          :hint="purchaseItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{purchaseItemAdditionalInfo(data.item)}} </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <!-- <template v-slot:append-outer>
            <NewItemSelect
              ref="newItemSelect"
              newTitle="Adicionar Item"
              width="50%"
              openSelectButtonLabel="Adicionar Item"
              :inlineAddButton="true"
              @entry-created="itemCreated"
            />
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="12" sm="12" :key="packagingCardsKey+'_key'">

      
      <v-card v-for="item in this.entry.itemGoals" class="my-custom-card">
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
              v-model="item.packaging.name"
              v-bind="getObject('item.packaging.name')"
              label="Nome embalagem"
              autocomplete="off"
              :disabled="true"
              />
            </v-col>

            <v-col cols="12" md="2" sm="2">
              <MaskedTextField
              mask-type="currency"
              v-model="item.quantity"
              v-bind="getObject('quantity')"
              :inputData.sync="item.quantity"
              @input="changeQuantity(item)"
              label="Quantidade"
              autocomplete="off"
              />
            </v-col>

            <v-col cols="12" md="2" sm="2">
              <MaskedTextField
              mask-type="currency"
              v-model="item.price"
              :inputData.sync="item.price"
              v-bind="getObject('price')"
              label="Preço"
              autocomplete="off"
              :disabled="true"
              />
            </v-col>

            <v-col cols="12" md="2" sm="2">
              <MaskedTextField
              mask-type="currency"
              :inputData.sync="item.totalPrice"
              v-bind="getObject('totalPrice')"
              label="Preço Total"
              autocomplete="off"
              :disabled="true"
              :key="totalPriceKey+'_key'"
              />
            </v-col>
            
          </v-row>
      </v-card>

      </v-col>

      <!-- <v-col cols="12" sm="12" md="6">
        <MaskedTextField
          v-bind="getObject('quantity')"
          :inputData.sync="entry.value"
          mask-type="currency_10d"
          label="Quantidade"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col> -->

      <!-- <v-col cols="12" sm="12" md="6">
        <MaskedTextField
          v-bind="getObject('commissionPercent')"
          :inputData.sync="entry.commissionPercent"
          mask-type="13v2"
          label="Percentual de comissão"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col> -->

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
      packagingCardsKey: 0,
      totalPriceKey: 0,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    item: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if(!this.entry.itemGoals){
      this.entry.itemGoals = [];
    }
    // console.log("item goal form", this.extraData);
    
  },
  mounted() {
    if(this.entry.item){
       this.purchaseItemsList.push(this.entry.item);
      //  this.selectItem();
      //  this.itemsSearch = this.entry.item.name;
      //  this.getPurchaseItems();
      //  this.$emit("entry-updated");
    }
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    changeQuantity: function(item){
      item.totalPrice = item.price * item.quantity;
      // console.log("veio aqui", item.quantity);
      this.totalPriceKey++;
    },
    selectItem: function() {
      // this.entry.item = this.extraData.accountContext.availableItemsForSale.find(obj => obj.id == this.entry.itemId);
      // this.packagingsList = [];

      // console.log("selectItem");
      // this.entry.itemGoals = [];
      // console.log("form", this.item, this.entry);
      this.entry.item = this.purchaseItemsList.filter(item=> item.id == this.entry.itemId)[0];

      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: ITEM_GOALS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            harvestId: this.item.harvestId,
            customerId: this.item.customerId,
          }
        })
        .then(response => {
          // console.log("response dos goals", response);
          // while(this.weights.length>0) {
          //   this.weights.pop();
          // }
          var resp = response.data.accountContext.itemGoals;
          console.log("resp", resp);
          // for(var r of resp){
          //   this.weights.push(r);
          // }
          this.entry.itemGoals = [];
          this.entry.itemGoals = resp;
          // this.entry.itemGoals.push(...resp);
          // this.entry.itemGoals.push(resp[0]);
          this.packagingCardsKey++;
          // var item = this.purchaseItemsList.find(item=> item.id == this.entry.itemId);
          // this.entry.item = item;
          // console.log("item", item);
          // let clearStorage = false;
          // if (this.packagingList.length == 1 && !this.entry.packagingId) {
          //   this.entry.packagingId = this.packagingList[0].id;
          //   clearStorage = clearPackagingAndStorage;
          // }
          // this.selectPackagingInStorage(clearStorage);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },
    purchaseItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Compra: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    getPurchaseItems: function() {
      this.purchaseItemsListLoading = true;
      this.$apollo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsSearch;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsSearch(query: $query) {
        id
        description
        name
        unit {
          name
        }
        brand {
          name
        }
        account{
          name
        }
        typeText
      }
    }
  }
`;

const ITEM_GOALS_QUERY = gql `
  query ($itemId: ID!, $customerId: ID!, $harvestId: ID!) {
    accountContext {
      itemGoals(itemId: $itemId, harvestId: $harvestId, customerId: $customerId){
        id
        packagingId
        packaging{
          name
          size
        }
        quantity
        price
      }
    }
  }
`;
</script>

<style scoped>
.my-custom-card {
      background-color: #aaffaa;
      border: 1px solid #ccc;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
      padding: 8px;
    }
</style>


